import React from 'react';
import { Tabs } from 'antd';
import { Wallet, TrendingUp } from 'lucide-react';
import BudgetActualsTab from './BudgetActualsTab';
import PLTab from './PLTab';

const FinanceIndex = () => {
  const items = [
    {
      key: 'budget-actuals',
      label: (
        <span className="flex items-center gap-2">
          <Wallet className="w-4 h-4" />
          Budget & Actuals
        </span>
      ),
      children: <BudgetActualsTab />,
    },
    {
      key: 'pl',
      label: (
        <span className="flex items-center gap-2">
          <TrendingUp className="w-4 h-4" />
          P&L
        </span>
      ),
      children: <PLTab />,
    },
  ];

  return (
    <div className="p-6 bg-background min-h-screen">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-foreground">Finance</h1>
        <p className="text-sm text-muted-foreground">Budget tracking, actuals, and profit & loss</p>
      </div>
      <Tabs
        defaultActiveKey="budget-actuals"
        items={items}
        size="large"
        className="finance-tabs"
        tabBarStyle={{
          backgroundColor: 'hsl(var(--card))',
          borderRadius: 16,
          padding: '4px 8px',
          border: '1px solid hsl(var(--border))',
          marginBottom: 24,
        }}
      />
    </div>
  );
};

export default FinanceIndex;
